import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { formatAsDollarsWithoutZeroCents } from 'common/source/utilities/strings';
import { openUrlInNewTab } from 'common/source/utilities/windowHelper';
import { ITimeoutService } from 'angular';
import { HippoApiService } from 'services/hippoApi';
import {
    getPageList,
    getPaginatedPastPayments,
    getPaginatedUpcomingPayments,
    getSortedPastPaidPaymentsAscending,
    getSortedUpcomingPaymentsAscending
} from './helper';
import {
    paymentMethodDisplayName
} from './helper/enums';

const module = angular.module('upcoming-and-past-payments-section', []);

interface UpcomingAndPastPaymentsSectionController extends angular.IStrictController {
    paymentMethod: string;
    policyInfo: CustomerPolicyInfo;
    pastPayments: Array<Array<PastCharge>>;
    paymentsToShow: Array<PastCharge> | Array<UpcomingPayment>;
    downloadReceipt: (payment: Payment) => void;
    formatAsDollarsWithoutZeroCents: (sum: number) => string;
    viewUpcomingPayments: boolean;
    currentPageIndex: number; // 0 based index
    paymentPages: Array<number>; // 0 based index
    upcomingPayments: Array<Array<UpcomingPayment>>;
    handlePageClick(pageIndex: number): void;
    handleViewPastPayments(): void;
    handleViewUpcomingPayments(): void;
    handlePreviousPageClick(): void;
    handleNextPageClick(): void;
}

module.component('upcomingAndPastPaymentsSection', {
    bindings: {
        policyInfo: '<'
    },
    template: template,
    controller: function(
        this: UpcomingAndPastPaymentsSectionController,
        $element: angular.IAugmentedJQuery,
        $timeout: ITimeoutService,
        hippoApiService: HippoApiService
    ) {
        const updatePaymentsLists = () => {
            this.pastPayments = getPaginatedPastPayments(getSortedPastPaidPaymentsAscending(this.policyInfo));
            this.upcomingPayments = getPaginatedUpcomingPayments(getSortedUpcomingPaymentsAscending(this.policyInfo));
        };

        const updateDisplay = () => {
            this.paymentsToShow = this.viewUpcomingPayments
                ? this.upcomingPayments[this.currentPageIndex]
                : this.pastPayments[this.currentPageIndex];
            this.paymentMethod = paymentMethodDisplayName[this.policyInfo.checkout_data.payment_method];
            this.paymentPages = getPageList(
                this.viewUpcomingPayments ? this.upcomingPayments.length : this.pastPayments.length
            );

            this.paymentsToShow = this.viewUpcomingPayments
                ? this.upcomingPayments[this.currentPageIndex]
                : this.pastPayments[this.currentPageIndex];
        };

        this.handlePageClick = (pageIndex: number) => {
            if (this.currentPageIndex !== pageIndex) {
                this.currentPageIndex = pageIndex;
                updateDisplay();
            }
        };

        this.$onInit = () => {
            this.currentPageIndex = 0;
            this.viewUpcomingPayments = true;
            updatePaymentsLists();
            updateDisplay();
        };

        this.formatAsDollarsWithoutZeroCents = (sum: number) => {
            return formatAsDollarsWithoutZeroCents(sum);
        };

        this.$onChanges = (changesObj) => {
            const policyInfo = changesObj.policyInfo;
            if (policyInfo && policyInfo.currentValue !== undefined) {
                $timeout(() => {
                    this.policyInfo = policyInfo.currentValue;
                    updatePaymentsLists();
                    updateDisplay();
                });
            }
        };

        this.handleViewPastPayments = () => {
            if (this.viewUpcomingPayments) {
                this.viewUpcomingPayments = false;
                this.currentPageIndex = 0;
                updateDisplay();
            }
        };

        this.handleViewUpcomingPayments = () => {
            if (!this.viewUpcomingPayments) {
                this.viewUpcomingPayments = true;
                this.currentPageIndex = 0;
                updateDisplay();
            }
        };

        this.handlePreviousPageClick = () => {
            if (this.currentPageIndex > 0) {
                this.currentPageIndex--;
                updateDisplay();
            }
        };

        this.handleNextPageClick = () => {
            if (this.currentPageIndex < this.paymentPages.length - 1) {
                this.currentPageIndex++;
                updateDisplay();
            }
        };

        this.downloadReceipt = (payment: Payment) => {
            const policyId = this.policyInfo.id;
            hippoApiService.createInvoice(policyId, payment).then((result) => {
                openUrlInNewTab(result.data.url);
            });
        };
    }
});

export { module };
